export enum AlertType {
    In_App_Notification = "In-app notification",
    Email = "Email",
    Both = "Both In-app & Email",
    None = "None"
}

export enum AlertSubType {
    Email = "Email",
    In_App = "In-app"
}